// Register.js
// Form Input refs: https://stackoverflow.com/a/65885351

import React, { useEffect, useRef, useState } from "react";
import { Image, StyleSheet, Text, TouchableOpacity, View, Platform } from "react-native";
//import AsyncStorage from "@react-native-async-storage/async-storage";
import Anchor from "components/Partials/Anchor";
import Button from "components/Partials/Buttons";
import Checkbox from "components/Partials/Checkbox";
import TextInputRef from "components/Partials/TextInputRef";
import formRefs from "components/helpers/formrefs";
import logo from "components/assets/logo.png";
import { ScreenLoading } from "components/Partials/Status";
import { triggerAlert } from "components/Partials/AlertModal";

const Register = () => {
  const _theme = window.main.theme;
  const [regDataState, regDataSetState] = useState({});
  const [regLocationState, regLocationSetState] = useState({});
  const [isScreenLoading, setIsScreenLoading] = useState(false);
  const [tosIsMarked, tosSetIsMarked] = useState(false);
  const [iHaveCodeState, iHaveCodeSetState] = useState(false);
  const [isSetPasswordState, isSetPasswordSetState] = useState(false);
  const [emailSentToState, emailSentToSetState] = useState("");
  const registerFormRefs = useRef(new formRefs());

  const markingTosCheckbox = (val)=>{
    console.log("val =", val);
    tosSetIsMarked(!!val);
  };

  const onSubmitRegistration = async () => {
    const formData = registerFormRefs.current.getAll();
    if (!("firstname" in formData) || !formData.firstname.trim()) {
      triggerAlert({
        show: true,
        title: "First Name field is required",
        message: "Please enter your first name\nto register your account.",
        onConfirmPressed: async () => {
          triggerAlert();
        },
      });
      return false;
    }
    if (!("lastname" in formData) || !formData.lastname.trim()) {
      triggerAlert({
        show: true,
        title: "Last Name field is required",
        message: "Please enter your last name\nto register your account.",
        onConfirmPressed: async () => {
          triggerAlert();
        },
      });
      return false;
    }
    if (!("email" in formData) || !formData.email.trim()) {
      triggerAlert({
        show: true,
        title: "Email is required",
        message: "Please enter your email\nto register your account.",
        onConfirmPressed: async () => {
          triggerAlert();
        },
      });
      return false;
    }
    if (!("phone" in formData) || !formData.phone.trim()) {
      triggerAlert({
        show: true,
        title: "Phone is required",
        message: "Please enter your phone number\nto register your account.",
        onConfirmPressed: async () => {
          triggerAlert();
        },
      });
      return false;
    }
    // Submit
    try {
      setIsScreenLoading(true);
      const postData = {};
      for (const field in formData) {
        postData[field] = formData[field];
      }
      postData.locationkey = (regLocationState.location_key||0);
      const register_resp = await window.main.axios.post(window.main.api.register, postData);
      setIsScreenLoading(false);
      if (!!register_resp.data?.success) {
        if (!!register_resp.data?.status && register_resp.data.status==="LOCATION_ADDED") {
          triggerAlert({
            show: true,
            title: "Success!",
            message: `Your existing account has been linked to ${register_resp.data.location_name||"this location. Please login again."}.`,
            showConfirmButton: true,
            confirmText: "Ok",
            onConfirmPressed: () => {
              triggerAlert();
              backToLogin();
            },
          });
          return;
        }
        regDataSetState(p=>({...p,...postData}));
        goToConfirmCode();
        return;
      } else {
        return window.setTimeout(() => {
          triggerAlert({
            show: true,
            title: "Oops!",
            message: (register_resp.data?.message || "Registration failed. Please check your information and submit again."),
            showConfirmButton: true,
            confirmText: "Ok",
            onConfirmPressed: () => {
              triggerAlert();
            },
          });
        },1);
      }
    } catch (err) {
      console.log("API response error:", err);
      // Non-200 response...
      setIsScreenLoading(false);
      let errMsg = window.main.lib.parseErrorMessage(err);
      if (!errMsg || typeof(errMsg)!=="string") {
        errMsg = "An error occurred. Please try again."
      }
      triggerAlert({
        show: true,
        title: "Oops!",
        message: errMsg,
        showConfirmButton: true,
        confirmText: "Ok",
        onConfirmPressed: () => {
          triggerAlert();
        },
      });
    }
  };

  const onSubmitConfirmation = async () => {
    const formData = registerFormRefs.current.getAll();
    if ((!("email" in formData) || !formData.email.trim()) && !regDataState.email) {
      triggerAlert({
        show: true,
        title: "Email is required",
        message: "Please enter your email\nto register your account.",
        onConfirmPressed: async () => {
          triggerAlert();
        },
      });
      return false;
    }
    if (!("confirmcode" in formData) || !formData.confirmcode.trim()) {
      triggerAlert({
        show: true,
        title: "Confirmation Code is required",
        message: "Please enter the confirmation Code\nfrom your email.",
        onConfirmPressed: async () => {
          triggerAlert();
        },
      });
      return false;
    }
    // Submit
    try {
      setIsScreenLoading(true);
      const postData = {
        email: (formData.email||regDataState.email),
        confirmcode: formData.confirmcode,
      };
      const confirmcode_resp = await window.main.axios.post(window.main.api.registerconfirm, postData);
      setIsScreenLoading(false);
      if (!!confirmcode_resp.data?.success) {
        regDataSetState(p=>({...p,...postData}));
        isSetPasswordSetState(true);
        return;
      } else {
        return window.setTimeout(() => {
          triggerAlert({
            show: true,
            title: "Oops!",
            message: (confirmcode_resp.data?.message || "Verifying your confirmation code failed. Please check your information and submit again."),
            showConfirmButton: true,
            confirmText: "Ok",
            onConfirmPressed: () => {
              triggerAlert();
            },
          });
        },1);
      }
    } catch (err) {
      console.log("API response error:", err);
      // Non-200 response...
      setIsScreenLoading(false);
      let errMsg = window.main.lib.parseErrorMessage(err);
      if (!errMsg || typeof(errMsg)!=="string") {
        errMsg = "An error occurred. Please try again."
      }
      triggerAlert({
        show: true,
        title: "Oops!",
        message: errMsg,
        showConfirmButton: true,
        confirmText: "Ok",
        onConfirmPressed: () => {
          triggerAlert();
        },
      });
    }
  };

  const onSubmitRegComplete = async () => {
    const formData = registerFormRefs.current.getAll();
    if (!regDataState.email) {
      iHaveCodeState(false);
      isSetPasswordSetState(false);
      return false;
    }
    if (!regDataState.confirmcode) {
      iHaveCodeState(false);
      isSetPasswordSetState(false);
      return false;
    }
    if (!("password" in formData) || !("confirmpw" in formData) || formData.password!==formData.password) {
      triggerAlert({
        show: true,
        title: "Passwords to not match",
        message: "Please check that your password\nand confirmation password match.",
        onConfirmPressed: async () => {
          triggerAlert();
        },
      });
      return false;
    }
    // Submit
    try {
      setIsScreenLoading(true);
      const postData = {
        email: regDataState.email,
        confirmcode: regDataState.confirmcode,
        password: formData.password,
      };
      const completereg_resp = await window.main.axios.post(window.main.api.registercomplete, postData);
      setIsScreenLoading(false);
      if (!!completereg_resp.data?.success) {
          triggerAlert({
            show: true,
            title: "Registration Complete!",
            message: "Your new account is ready.\n\nYou will be redirected to the\nlogin screen to access your account.",
            showConfirmButton: true,
            confirmText: "Ok",
            onConfirmPressed: () => {
              window.main.lib.setCurrentView("login");
              triggerAlert();
            },
          });
        return;
      } else {
        return window.setTimeout(() => {
          triggerAlert({
            show: true,
            title: "Oops!",
            message: (completereg_resp.data?.message || "Completing your account registration failed. Please check your information and submit again."),
            showConfirmButton: true,
            confirmText: "Ok",
            onConfirmPressed: () => {
              triggerAlert();
            },
          });
        },1);
      }
    } catch (err) {
      console.log("API response error:", err);
      // Non-200 response...
      setIsScreenLoading(false);
      let errMsg = window.main.lib.parseErrorMessage(err);
      if (!errMsg || typeof(errMsg)!=="string") {
        errMsg = "An error occurred. Please try again."
      }
      triggerAlert({
        show: true,
        title: "Oops!",
        message: errMsg,
        showConfirmButton: true,
        confirmText: "Ok",
        onConfirmPressed: () => {
          triggerAlert();
        },
      });
    }
  };

  const goToConfirmCode = async () => {
    const formData = registerFormRefs.current.getAll();
    if (!!("email" in formData) && !!formData.email.trim()) {
      emailSentToSetState(formData.email);
    }
    iHaveCodeSetState(true);
  };

  const backToRegister = async () => {
    iHaveCodeSetState(false);
  };

  const backToLogin = async () => {
    window.main.lib.setCurrentView("login");
  };

  const onKeyPressEnterSubmit = (e) => {
    if(e.key==="Enter") {
      if (!!iHaveCodeState && !!isSetPasswordState) {
        onSubmitRegComplete();
      } else if (!!iHaveCodeState && !isSetPasswordState) {
        onSubmitConfirmation();
      } else {
        onSubmitRegistration();
      }
    }
  };

  // Launch only once:
  useEffect(()=>{
    const ckLoc = async ()=>{
      const regUrlPathParams = window.main.lib.getAllWebUrlParams();
      if (!!regUrlPathParams.length && regUrlPathParams[0].length===32) {
        setIsScreenLoading(true);
        const loc_resp = await window.main.axios.post(window.main.api.locationdata.replace("{locationkey}",regUrlPathParams[0]));
        if (!!loc_resp && !!loc_resp.data && !!loc_resp.data.location_id) {
          regLocationSetState(loc_resp.data);
        }
        setIsScreenLoading(false);
      }
    };
    ckLoc();
  },[]);

  const styles = window.main.theme.externalUserPagesStyles;
  const _firstname_ref = useRef();
  const _lastname_ref = useRef();
  const _email_ref = useRef();
  const _phone_ref = useRef();
  const _tos_ref = useRef();
  const _confirmcode_ref = useRef();
  const _password_ref = useRef();
  const _confirmpw_ref = useRef();
  const [isPasswordHiddenState, isPasswordHiddenSetState] = useState(true);
  const [isConfirmPwHiddenState, isConfirmPwHiddenSetState] = useState(true);
  const toggleIsPasswordHidden = ()=>{
    isPasswordHiddenSetState(s=>(!s));
  };
  const toggleIsConfirmPwHidden = ()=>{
    isConfirmPwHiddenSetState(s=>(!s));
  };

  // Registration Form
  return (
    <View style={{...styles.container,position:"static"}}>
      <View style={{...styles.wrapper,flexDirection:"column",alignItems:"center",position:"static"}}>
        <View style={styles.headerRow}>
          <Image nativeID={"brand_logo"} style={styles.headerLogo} source={logo} resizeMode={"cover"} accessibilityLabel={"VetManaged Logo"} />
          <Text nativeID={"app_title"} style={styles.headerTitle}> PetManaged</Text>
        </View>
        <View style={styles.headerRow}>
          <Text style={{...styles.headerTitle,textAlign:"center"}}>{!!regLocationState && !!Number(regLocationState.location_id) ? (regLocationState.location_name||regLocationState.location_shortname)+" Registration" : "Existing Client Registration"}</Text>
        </View>
        {!iHaveCodeState && !isSetPasswordState &&
          <>
            <View style={{width:250,alignSelf:"center"}}>
              <Text style={{..._theme.fieldLabelInline}}>First Name: *</Text>
              <TextInputRef key="register_firstname" ref={_firstname_ref} nativeID="input_firstname" textContentType="firstname" autoComplete="firstname" formrefs={registerFormRefs.current} datakey={"firstname"} placeholder="First Name..." style={{...window.main.theme.textInputLarge,marginBottom:12}} onKeyPress={onKeyPressEnterSubmit} autoFocus={true} />
              <Text style={{..._theme.fieldLabelInline}}>Last Name: *</Text>
              <TextInputRef key="register_lastname" ref={_lastname_ref} nativeID="input_lastname" textContentType="lastname" autoComplete="lastname" formrefs={registerFormRefs.current} datakey={"lastname"} placeholder="Last Name..." style={{...window.main.theme.textInputLarge,marginBottom:12}} onKeyPress={onKeyPressEnterSubmit} />
              <Text style={{..._theme.fieldLabelInline}}>Email: *</Text>
              <TextInputRef key="register_email" ref={_email_ref} nativeID="input_email" textContentType="email" autoComplete="email" formrefs={registerFormRefs.current} datakey={"email"} placeholder="Email Address..." style={{...window.main.theme.textInputLarge,marginBottom:12}} onKeyPress={onKeyPressEnterSubmit} />
              <Text style={{..._theme.fieldLabelInline}}>Phone Number: *</Text>
              <TextInputRef key="register_phone" ref={_phone_ref} nativeID="input_phone" textContentType="phone" autoComplete="phone" formrefs={registerFormRefs.current} datakey={"phone"} placeholder="Phone Number..." style={{...window.main.theme.textInputLarge,marginBottom:12}} onKeyPress={onKeyPressEnterSubmit} />
              <View style={{paddingHorizontal:0,flexDirection:"row",alignItems:"flex-start"}}>
                <Checkbox key="tos_marked" ref={_tos_ref} nativeID="checkbox_tos" onChange={markingTosCheckbox} labelStyle={{fontSize:12}} />
                <Text style={{flexDirection:"row",paddingLeft:6,paddingTop:4}}>
                  I have read and agree to the{"\n"}
                  <Anchor href="https://vetmanaged.com/docs/Vet%20Managed%20Terms%20and%20Conditions.pdf" style={{display:"inline-block"}}>Terms of Service</Anchor> documents.
                </Text>
              </View>
            </View>
            <View style={{...styles.headerRow,height:"auto",padding:10}}>
              {(!regLocationState || !Number(regLocationState.location_id)) &&
                <Text style={{textAlign:"center"}}>
                  You will be emailed a confirmation code to complete your registration.{"\n\n"}
                  New clients: Please contact your{"\n"}clinic, or on their website find {"\n"}'PetManaged App Registration'.
                </Text>
              }
              {!!regLocationState && !!Number(regLocationState.location_id) &&
                <Text style={{textAlign:"center"}}>
                  If you are an existing user,{"\n"}your existing account will be{"\n"}registed with this clinic location.{"\n\n"}
                  If you are a new user, you will{"\n"}be emailed a confirmation code{"\n"}to complete your registration.
                </Text>
              }
            </View>
            <Button nativeID="button_register" type="primary" ficon="user-plus" text="Register" onpress={onSubmitRegistration} style={{width:250,marginTop:0}} disabled={!tosIsMarked} />
            <Button nativeID="button_ihavecode" type="link" ficon="check-square" text="I have a Code" onpress={goToConfirmCode} style={{width:250,marginTop:20}} />
            <Button nativeID="button_ihavecode" type="link" ficon="arrow-left" text="Back to Login" onpress={backToLogin} style={{width:250,marginTop:10}} />
          </>
        }
        {!!iHaveCodeState && !isSetPasswordState &&
          <>
            <View style={{width:250,alignSelf:"center"}}>
              {!emailSentToState &&
                <>
                  <Text style={{..._theme.fieldLabelInline}}>Email:</Text>
                  <TextInputRef key="register_email" ref={_email_ref} nativeID="input_email" textContentType="email" autoComplete="email" formrefs={registerFormRefs.current} datakey={"email"} placeholder="Email Address" style={{...window.main.theme.textInputLarge,marginBottom:12}} onKeyPress={onKeyPressEnterSubmit} />
                </>
              }
              {!!emailSentToState &&
                <>
                  <Text style={{textAlign:"center"}}>An email was sent to{"\n"}<Text style={{fontWeight:"600",lineHeight:30}}>{emailSentToState}</Text>{"\n"}containing a confirmation code.{"\n\n"}</Text>
                  <Text style={{textAlign:"center"}}>Please enter the{"\n"}confirmation code below.{"\n"}{"\n"}</Text>
                </>
              }
              <Text style={{..._theme.fieldLabelInline}}>Confirmation Code:</Text>
              <TextInputRef key="register_confirmcode" ref={_confirmcode_ref} nativeID="input_confirmcode" textContentType="confirmcode" autoComplete="confirmcode" formrefs={registerFormRefs.current} datakey={"confirmcode"} placeholder="Confirmation Code" style={{...window.main.theme.textInputLarge,marginBottom:12}} onKeyPress={onKeyPressEnterSubmit} autoFocus={true} />
            </View>
            <Button nativeID="button_submitcode" type="primary" ficon="check-square" text="Confirm" onpress={onSubmitConfirmation} style={{width:250,marginTop:20}} />
            <Button nativeID="button_backtoregister" type="link" ficon="arrow-left" text="Back to Register" onpress={backToRegister} style={{width:250,marginTop:10}} />
          </>
        }
        {!!iHaveCodeState && !!isSetPasswordState &&
          <>
            <View style={{width:250,alignSelf:"center"}}>
              <Text style={{..._theme.fieldLabelInline}}>Password:</Text>
              <View style={{position:"relative"}}>
                <TextInputRef key="_password_ref" ref={_password_ref} nativeID="input_password" textContentType="password" autoComplete="password" formrefs={registerFormRefs.current} datakey={"password"} placeholder="Password" style={{...window.main.theme.  textInputLarge,marginBottom:12,paddingRight:30}} secureTextEntry={isPasswordHiddenState} onKeyPress={onKeyPressEnterSubmit} />
                <Button nativeID="button_toggle_passwordhidden" type="link" ficon={!!isPasswordHiddenState?"eye-off":"eye"} text="" onpress={toggleIsPasswordHidden} style={{position:"absolute",top:3,right:8,paddingHorizontal:0}} iconSize={15} />
              </View>
              <Text style={{..._theme.fieldLabelInline}}>Confirm Password:</Text>
              <View style={{position:"relative"}}>
                <TextInputRef key="_confirmpw_ref" ref={_confirmpw_ref} nativeID="input_confirmpw" textContentType="confirmpw" autoComplete="confirmpw" formrefs={registerFormRefs.current} datakey={"confirmpw"} placeholder="Confirm Password" style={{...window.main.theme.textInputLarge,marginBottom:12,paddingRight:30}} secureTextEntry={isConfirmPwHiddenState} onKeyPress={onKeyPressEnterSubmit} />
                <Button nativeID="button_toggle_confirmpwhidden" type="link" ficon={!!isConfirmPwHiddenState?"eye-off":"eye"} text="" onpress={toggleIsConfirmPwHidden} style={{position:"absolute",top:3,right:8,paddingHorizontal:0}} iconSize={15} />
              </View>
            </View>
            <Button nativeID="button_submitpw" type="primary" ficon="check-square" text="Complete" onpress={onSubmitRegComplete} style={{width:250,marginTop:20}} />
          </>
        }
        <ScreenLoading loadingState={isScreenLoading} style={{paddingTop:100,opacity:0.7}} />
      </View>
    </View>
  );
};

export default Register;
